import React, { useEffect, useState } from "react";
import { DataTable, DataTableBody, DataTableHead, DataTableItem, DataTableRow } from "../../../../components/Component";
import { Badge } from "reactstrap";
import { convertHexToColor } from "../../../../utils/Functions";
import moment from "moment";
import { apiService } from "../../../../services/api";
import { APIServicePath } from "../../../../services/api/api-service-impl";
import { toPageInfo } from "../../../_common/DataConverter";

const Availabilitidata = ({ hList, vList, currentPage, matrixPageInfo, loading, setCurrentPage }) => {
  useEffect(() => {
    const scrollableDiv = document.getElementById("scroll-matrix2");
    scrollableDiv?.addEventListener("scroll", handleScroll, true);
    return () => {
      scrollableDiv?.removeEventListener("scroll", handleScroll, true);
    };
  }, [currentPage, loading]);
  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 5 && !loading && currentPage < matrixPageInfo?.totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  return (
    <div className="matrix-table h-100">
      <div className="height-matrix-card" id="scroll-matrix2">
        <DataTable className="h-100 card-stretch overflow-auto border border-light-gray mx-10">
          <DataTableBody>
            {/* Table Headers */}
            <DataTableHead>
              {hList.map((date, index) => (
                <DataTableRow key={index} className="border-light-gray-right text-center px-2 border-bottom">
                  <span className="matrix-font-day">{moment(date).format("ddd")}</span>
                  <span className="sub-text matrix-font-date">{moment(date).format("DD/MM")}</span>
                </DataTableRow>
              ))}
            </DataTableHead>

            {/* Table Data */}
            <DataTableItem className="t-body matrix-card-align-top">
              {hList.map((date, index) => {
                const shifts = vList.filter(
                  (shift) => moment(shift.availableDate).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD")
                );
                if (shifts.length === 0) {
                  return null;
                }

                return (
                  <DataTableRow key={index} className="border-light-gray-right text-black text-center px-2">
                    {shifts.map((shift, i) => {
                      let color =
                        shift?.grade?.length > 1
                          ? "outline-light"
                          : `outline-${convertHexToColor(shift?.grade?.[0]?.colourHex) ?? ""}`;

                      return (
                        <Badge
                          key={`${index}-${i}`}
                          // onClick={() => handleShowDetail(shift)}
                          color={color}
                          className="badge-dim badge-sm availabilities-text-card cursor-pointer w-100 "
                        >
                          <div className="d-flex align-items-center">
                            <span className="text-dark d-flex gap-1 justify-content-center align-items-center">
                              {`${shift.carer?.firstName} ${shift.carer?.lastName}`}
                              {shift.shiftType !== "ANY" && (
                                <img
                                  alt="Shift Icon"
                                  src={
                                    shift.shiftType === "DAY"
                                      ? require("../../../../assets/images/jsTree/shiftIcon/Sun.png")
                                      : shift.shiftType === "NIGHT"
                                      ? require("../../../../assets/images/jsTree/shiftIcon/Moon.png")
                                      : null
                                  }
                                  style={{ width: "12px", height: "12px" }}
                                  className="me-1"
                                />
                              )}
                            </span>
                          </div>
                        </Badge>
                      );
                    })}
                  </DataTableRow>
                );
              })}
            </DataTableItem>
          </DataTableBody>
          {vList.length === 0 && (
            <span className="d-flex justify-content-center border-bottom">There is no data found</span>
          )}
        </DataTable>
      </div>
    </div>
  );
};

export default Availabilitidata;

export function availabilitiesListApi(params, callback) {
  apiService
    .postCall(APIServicePath.availabilitiesList, params, 30000)
    .then((data) => {
      let list = data.list;
      let pageInfo = toPageInfo(data?.pageInfo);

      callback({ list, pageInfo }, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}
export function exportAvailabilitiesAPI(params, callback) {
  apiService
    .postCall(APIServicePath.exportAvailabilities, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}
